import React from 'react';

import { useDefaultInvoice } from 'src/hook';

import PriceOverview from './priceOverview';
import DropdownCurrency from 'src/components/dropdownCurrency';

const InvoiceDefault: React.FC = (): JSX.Element => {
  useDefaultInvoice();

  return (
    <>
      <PriceOverview />
      <DropdownCurrency />
    </>
  );
};

export default InvoiceDefault;
